module.exports = __webpack_public_path__ + "img/forgot-password-email-sent-framme-store.b6fe4196.png";